import { useState, useEffect, useRef } from "react";
import { AiOutlineClose, AiOutlineDown } from "react-icons/ai";
import { FaTwitter, FaTelegramPlane, FaInstagram, FaFacebookF, FaGithub } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import Slice from '../reducer'
import toast, { Toaster } from "react-hot-toast";
import { getAddress, sendBtcTransaction } from "sats-connect";
import { useNavigate } from 'react-router-dom';

const WalletModal = ({ setWalletModal }: any) => {

	const [walletCheck, setWalletCheck] = useState('unisat');

	const [height, setHeight] = useState<number>(0);
	useEffect(() => {
		setHeight(window.innerHeight);
	}, [window.innerHeight])


	// wallet connect
	const global = useSelector((state: any) => state);
	const dispatch = useDispatch();
	const update = (payload: { [key: string]: any }) => {
		dispatch(Slice.actions.update(payload));
	};


	const [isOpen, setIsOpen] = useState(false)

	const handleClickMenu = () => {
		setIsOpen(!isOpen)
	}
	const handleCloseMenu = () => {
		setIsOpen(false) // Close the menu
	}

	// ------------------
	const [openModal, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleCloseModal = () => setOpen(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: any) => {
		if (connected) {
			setAnchorEl(event.currentTarget);
		} else {
			handleOpen();
		}
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	//   -------------------------------

	const [walletConnectModal, setWalletConnectModal] = useState(false);
	const [address, setAddress] = useState(null);
	const [unisatInstalled, setUnisatInstalled] = useState(false);
	const [connected, setConnected] = useState(false);
	const [publicKey, setPublicKey] = useState("");
	const [timeEnded, setTimeEnded] = useState(false);
	const [network, setNetwork] = useState("livenet");
	const [balance, setBalance] = useState({
		confirmed: 0,
		unconfirmed: 0,
		total: 0,
	});
	const [depositValue, setDepositValue] = useState(0);

	const [selectedwallet, setSelectedwallet] = useState("unisat");

	const selfRef = useRef({
		accounts: [],
	});

	const self = selfRef.current;
	const onWalletConnect  = async ()=>{
		if(walletCheck == 'unisat'){
			UnisatWalletConnect();
		}else if(walletCheck == 'xverse'){
			XverseWalletConnect();
		} else if (walletCheck == 'okx') {
			OkxWalletConnect();
		} else if (walletCheck == 'leather') {
			LeatherWalletConnect();
		}
	}
	const getBasicInfo = async () => {
		const unisat = window.unisat;
		const [address] = await unisat.getAccounts();
		setAddress(address)
		update({ address: address })

		const publicKey = await unisat.getPublicKey();
		setPublicKey(publicKey);

		const balance = await unisat.getBalance();
		setBalance(balance);
		update({ balance: balance })

		const network = await unisat.getNetwork();
		setNetwork(network);
	};

	const UnisatWalletConnect = async () => {
		try {
			const result = await window.unisat.requestAccounts();
			const balance = await window.unisat.getBalance();
			setBalance(balance);
			update({ balance: balance })

			handleAccountsChanged(result);
			console.log(result)
			setConnected(true);
			setOpen(false);
			setSelectedwallet("unisat");

			update({ selectedwallet: 'unisat' })

		} catch (error: any) {
			toast.error(error.message);
		}
	};

	const XverseWalletConnect = async () => {
		try {
			const getAddressOptions: any = {
				payload: {
					purposes: ["payment"],
					message: "Address for receiving payments",
					network: {
						// type: "Testnet",
						type: "Mainnet",
					},
				},
				onFinish: (response: any) => {
					console.log(response);
					setAddress(response.addresses[0].address)
					update({ address: response.addresses[0].address })

					setConnected(true);
					setOpen(false);
					setSelectedwallet("xverse");
					update({ selectedwallet: 'xverse' })

				},
				onCancel: () => toast.error("Request canceled"),
			};

			await getAddress(getAddressOptions);
		} catch (error) {
			console.log(error);
		}
	};

	const OkxWalletConnect = async () => {
		try {
			if (typeof window.okxwallet === "undefined") {
				toast.error("OKX is not installed!");
			} else {
				const result = await window.okxwallet.bitcoin.connect();
				setAddress(result.address)
				update({ address: 'address' })
				setConnected(true);
				setOpen(false);
				setSelectedwallet("okx");
				update({ selectedwallet: 'okx' })
			}
		} catch (error: any) {
			toast.error(error.message);
		}
	};

	const LeatherWalletConnect = async () => {
		try {
			const userAddresses = await window.btc?.request("getAddresses");
			const usersNativeSegwitAddress = userAddresses.result.addresses.find(
				(address: any) => address.type === "p2wpkh"
			);
			setAddress(usersNativeSegwitAddress.address)
			update({ address: 'address' })
			setConnected(true);
			setOpen(false);
			setSelectedwallet("leather");
			update({ selectedwallet: 'leather' })
		} catch (error: any) {
			toast.error(error.message);
		}
	};

	const handleAccountsChanged = (_accounts: any) => {
		// if (self.accounts[0] === _accounts[0]) {
		//   // prevent from triggering twice
		//   setOpen(false);
		//   return;
		// }
		self.accounts = _accounts;
		if (_accounts.length > 0) {

			setConnected(true);
			update({ connected: 'true' })
			setAddress(_accounts[0])

			update({ accounts: _accounts[0] })
			getBasicInfo();
		} else {
			setConnected(false);
			update({ connected: false })
		}
		setWalletConnectModal(false);
	};

	const handleNetworkChanged = (network: any) => {
		setNetwork(network);
		getBasicInfo();
	};

	const DisconnectWallet = () => {
		setConnected(false);
		setBalance({
			confirmed: 0,
			unconfirmed: 0,
			total: 0,
		});
		update({ accounts: [] })
		handleClose();
	};

	return (
		<>

			<div className="wallet-modal-container">
				<div
					className="wallet-modal-bg"
					onClick={() => setWalletModal(false)}
				></div>
				<div className="wallet-modal-body" style={{ maxHeight: `${height - 150}px` }}>
					<div className="wallet-modal-header w-full m-auto py-3 px-6 ">
						<div className="flex items-center justify-between w-full">
							<h4 className="text-white">Wallet Connect</h4>
							<div onClick={() => setWalletModal(false)} className="p-2 rounded-full border border-gray-600 cursor-pointer">
								<AiOutlineClose color="white" fontSize={'25px'} />
							</div>
						</div>
					</div>
					<div className="px-10 py-6 w-full modal-content">
						<div className="mt-6">
							<div className="row">
								<div className="col-sm-12 col-md-6 mb-4">
									<div onClick={() => setWalletCheck('unisat')} className="checker-container !mt-0">
										<img src={`/assets/images/check/${walletCheck == 'unisat' ? 'check' : 'uncheck'}.png`} alt="" className="w-5 h-5" />
										<div className="flex gap-2 items-center">
											<img src={`/assets/images/wallet/unisat.jpg`} alt="" className="wallet-image" />
											<span className="text-white">Unisat</span>
										</div>
									</div>
									<div onClick={() => setWalletCheck('xverse')} className="checker-container">
										<img src={`/assets/images/check/${walletCheck == 'xverse' ? 'check' : 'uncheck'}.png`} alt="" className="w-5 h-5" />
										<div className="flex gap-2 items-center">
											<img src={`/assets/images/wallet/xverse.jpg`} alt="" className="wallet-image" />
											<span className="text-white">Xverse</span>
										</div>
									</div>
									<div onClick={() => setWalletCheck('leather')} className="checker-container">
										<img src={`/assets/images/check/${walletCheck == 'leather' ? 'check' : 'uncheck'}.png`} alt="" className="w-5 h-5" />
										<div className="flex gap-2 items-center">
											<img src={`/assets/images/wallet/leather.jpg`} alt="" className="wallet-image" />
											<span className="text-white">Leather</span>
										</div>

									</div>
									<div onClick={() => setWalletCheck('okx')} className="checker-container">
										<img src={`/assets/images/check/${walletCheck == 'okx' ? 'check' : 'uncheck'}.png`} alt="" className="w-5 h-5" />
										<div className="flex gap-2 items-center">
											<img src={`/assets/images/wallet/okx.png`} alt="" className="wallet-image" />
											<span className="text-white">OKX</span>
										</div>
									</div>
								</div>
								<div className="col-sm-12 col-md-6 mb-4">
									<div className="flex justify-around flex-col h-full">
										<div className="">
											<span className="text-white">
												Please select bitcoin wallet that connect to your wallet.
												<br />
												Next, please click wallet connect
											</span>
										</div>
										<div className="">
											<button onClick={onWalletConnect} className="btn primary-bg text-black w-full mt-2">
												<span className="">Connect Wallet</span>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default WalletModal;
